import React from 'react';
import PageHero from '../components/PageHero';
import CurriculumSection from '../components/CurriculumSection';
import MovingText from '../components/MovingText';

const Curriculum = () => {
    return (
        <>
            <PageHero title="Learning Through Curiosity & Hygge" />
            <CurriculumSection />
            <MovingText />
        </>
    );
};

export default Curriculum;
